export enum OfferStatusEnum {
  ENDANGERED = 1,
  ACTIVE = 2,
  SOLD = 3
}
